import { takeEvery, put, call } from 'redux-saga/effects';

//Account Redux states
import { RegisterTypes } from './actionTypes';
import { registerUserSuccessful, registerUserFailed } from './actions';

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { registerHelper } from '../../../helpers/register_helper';
import { API_URL } from '../../../helpers/url_helper';
import apiFetch from '../../../fetch';
import Swal from 'sweetalert2';

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }: any): any {
    console.log('Entro funcion registerUser en saga');
    const path = API_URL;
    const urlHost = window.location.origin;

    const { username, password, lastname, name, email, network_id } = user;
    const query = `mutation{
    createUser (Users:{
        USUARIO_LOGIN: "${username}",
        USUARIO_PASSWORD: "${password}",
        USUARIO_NOMBRE: "${name}",
        USUARIO_APELLIDO: "${lastname}",
        USUARIO_CORREO: "${email}",
        NETWORK_ID: ${network_id},
        url: "${urlHost}",
    }) 
}`;

    try {
        console.log('Entro al try de la funcion en saga');
        const opts = {
            authRequired: false,
            body: {
                query,
            },
            method: 'POST',
        };
        console.log('Entro al try de la funcion en saga - opts');
        //const casing = 'underscore';
        console.log('PARH ... '  + path);
        const resp: any = yield call(apiFetch, path, opts);
        console.log('Entro al try de la funcion en saga - yield call');
        const { data, errors } = resp.body;
        console.log('data ... '  + data);
        if (data?.createUser === 'success') {
            console.log("entro en data?.createUser === 'success'");
            yield put(registerUserSuccessful(data));
            Swal.fire({
                title: 'User registered',
                text: 'User has been registered successfully',
                icon: 'success',
            });
        } else if (data?.createUser === 'This email already exists.') {
            console.log('entro en data register user fail por email exists');
            yield put(registerUserFailed(data));
            Swal.fire({
                title: 'Error',
                text: data?.createUser,
                icon: 'error',
            });
        }
        console.log("end if");
    } catch (error) {
        console.log('Entro al catch de la funcion en saga');
        yield put(registerUserFailed(error));
    }
}

function* registerSaga() {
    console.log('entro en registerSaga');
    yield takeEvery(RegisterTypes.REGISTER_USER, registerUser);
}

export default registerSaga;
